<template>
  <article class='person' :class="{'is-active': active, 'is-visited': visited}" @click="addPersonToVisited">
    <router-link :to="`/${person.id}-${slug}`">
      <div class="person__image">
        <img
          v-lazy="`./people/thumb/${person.image}`"
          :alt="fullName"
        />
      </div>
      <div class="person__info">
        <h3 class="person__name">
          {{fullName}}
        </h3>
        <span class="person__meta">
          &lowast;&nbsp;{{parseInt(person.birthDate, 10)}}
          &nbsp;&ndash;&nbsp; &dagger;&nbsp;{{parseInt(person.deathDate, 10)
            ? parseInt(person.deathDate, 10)
            : 'neznámé'}}
        </span>
      </div>
    </router-link>
  </article>
</template>

<script>
import slug from "slug";

export default {
  data() {
    return {
      visited: false
    };
  },
  props: {
    person: Object,
    activePerson: Object
  },
  created() {
    const visitedPeople =
      JSON.parse(localStorage.getItem("visitedPeople")) || [];
    this.visited = visitedPeople.includes(this.person.id);
  },
  computed: {
    fullName() {
      return `${this.person.name} ${this.person.surname}`;
    },
    slug() {
      return slug(this.fullName);
    },
    active() {
      return this.activePerson && this.activePerson.id === this.person.id;
    }
  },
  methods: {
    addPersonToVisited() {
      const visitedPeople =
        JSON.parse(localStorage.getItem("visitedPeople")) || [];
      if (!visitedPeople.includes(this.person.id)) {
        visitedPeople.push(this.person.id);
      }
      localStorage.setItem("visitedPeople", JSON.stringify(visitedPeople));
      this.visited = true;
    }
  }
};
</script>

<style scoped>
.person {
  margin: 0.5rem;
  width: calc(100% - 1rem);
  align-items: center;
  display: flex;
  background-color: var(--colorWhite);
  transition: all 0.4s ease-in;
  border: 2px solid transparent;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.2);
  border-radius: 3px;
}

.person:hover,
.person.is-active {
  border-color: var(--colorPrimary);
  transition: all 0.4s ease-out;
}

.person:visited > a,
.person.is-visited > a {
  color: purple;
  opacity: 0.8;
}

.person a {
  padding: 0.5rem;
  width: 100%;
  display: flex;
  text-decoration: none;
  color: currentColor;
  align-items: center;
}

.person__image {
  border-radius: 50%;
  height: 36px;
  overflow: hidden;
  width: 36px;
}

.person__image img {
  max-width: 100%;
}

.person__info {
  margin-left: 0.5rem;
  flex: 1 0 0;
}

.person__name {
  margin: 0;
  font-size: 0.75rem;
}

.person__meta {
  font-size: 0.75rem;
}

@media (min-width: 480px) {
  .person {
    width: calc(50% - 1rem);
  }
}

@media (min-width: 992px) {
  .person {
    width: calc(33.333% - 1rem);
  }
}

@media (min-width: 1280px) {
  .person {
    width: calc(25% - 1rem);
  }
}

@media (min-width: 1600px) {
  .person {
    width: calc(20% - 1rem);
  }
}
</style>